import { render, staticRenderFns } from "./PayErpDialog.vue?vue&type=template&id=2bed1df0&scoped=true"
import script from "./PayErpDialog.vue?vue&type=script&lang=js"
export * from "./PayErpDialog.vue?vue&type=script&lang=js"
import style0 from "./PayErpDialog.vue?vue&type=style&index=0&id=2bed1df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed1df0",
  null
  
)

export default component.exports